<template>
    <el-dialog title="选择出库产品" :visible.sync="selectProductOutDialog" width="800px" :before-close="handleDialogClose"  append-to-body :close-on-click-modal="false" class="custom-form-dialog custom-inventory-dialog">
        <div class="product_select_out_wrap">
            <div class="product_select_out_top">
                <el-input size="small" v-model="keywords" placeholder="请输入产品名称"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch">
                    <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                </el-input>
            </div>
            <div class="product_select_flex_wrap">
                <div class="product_select_flex_left">
                    <ul>
                        <li @click="handleClickStockItem({id:''})" class="custom_hover_active_class font_bold "  :class="stock_id == '' ? 'active' : ''">所有产品</li>
                        <li v-for="item in stockList"  @click="handleClickStockItem(item)" class="custom_hover_active_class font_bold " :class="item.id == stock_id ? 'active' : ''">
                            <p class="ellipsis" >
                                <EllipsisTooltip :text="item.name" />
                            </p>
                        </li>



                    </ul>
                </div>
                <div class="product_select_flex_right">
                    <div class="product_select_code_bottom">
                        <el-table class="custom_table" :data="tableData" border height="477px" ref="multipleTable" row-key="id"  v-loading="loading">
                            <el-table-column label="产品名称" prop="name" show-overflow-tooltip min-width="230px"></el-table-column>
                            <el-table-column label="库存数量" prop="total_num" align="right" show-overflow-tooltip width="85px"></el-table-column>
                            <el-table-column label="所属仓库" prop="stocks" show-overflow-tooltip width="135px">
                                <template slot-scope="{row}">
                                    <span v-if="row.stocks" v-text="row.stocks.name" ></span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" prop="handle" align="center" show-overflow-tooltip width="65px">
                                <template slot-scope="{row,$index}">
                                    <el-button type="text" @click="handleDialogConfirm(row)">选择</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="product_select_code_pagination">
                        <el-pagination background
                                       size="mini"
                                       @size-change="handleSizeChange"
                                       @current-change="handleCurrentChange"
                                       :current-page="pagination.pageNum"
                                       :page-sizes="pagination.pageSizes"
                                       :page-size="pagination.pageSize"
                                       :layout="pagination.layout"
                                       :pager-count="5"
                                       :total="pagination.total">
                        </el-pagination>
                    </div>
                </div>
            </div>

        </div>
    </el-dialog>
</template>
<script>
import { stockList,stockProductList } from "@/api/index.js"
import {pagination} from '@/mixins'
import EllipsisTooltip from '@/components/pComponents/ellipsisTooltip';
import WarehouseTpl from "../warehouse_management/component/warehouse_tpl";
import ProductTransfer from "../warehouse_management/component/product_transfer";
import ProductDetail from "../warehouse_management/component/product_detail";
export default {
    name: "select_product_out",
    components: {
        EllipsisTooltip
    },
    props: {
        selectProductOutDialog: {
            type: Boolean,
            default: false
        },
        selectStockId: {
            type: [Number, String],
            default: ''
        },
        selectPorductName: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            loading:false,
            keywords:'',
            BtnDisabled:false,
            tableData:[],
            stockList:[],
            stock_id:'',
        }
    },
    mixins: [pagination],
    created() {
        if(this.selectStockId){
            this.stock_id = this.selectStockId
        }
        this.getStockList()
        this.getTableData()
    },
    methods: {
        // 获取仓库
        getStockList(){
            stockList({}).then(res => {
                if (res.code === 200) {
                    this.stockList = res.data
                }
            })
        },
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.getTableData()
        },

        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },
        handleClickStockItem(item){
            // if(this.selectStockId){
            //     return false
            // }
            this.stock_id = item.id
            this.handleClickSearch()
        },
        getTableData(){
            let postData  = {
                keyword:this.keywords,
                id:this.stock_id,
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
            }
            this.loading = true
            stockProductList(postData).then(res => {
                if (res.code === 200) {
                    let {list,total} = res.data
                    list.forEach((item,index)=>{
                        this.$set(item.stocks,'no_code_num',item.no_code_num)
                        this.$set(item.stocks,'code_num',item.code_num)
                        this.$set(item.stocks,'total_num',item.total_num)
                    })
                    this.tableData = list
                    this.pagination.total = total
                }
                this.loading = false
            })
        },
        handleDialogClose() {
            this.$emit("update:selectProductOutDialog", false)
        },
        handleDialogConfirm(row) {
            this.$emit("success", row)
            this.$emit("update:selectProductOutDialog", false)
        },

    }
}
</script>
<style  lang="scss" scoped>
::v-deep .el-pagination__jump{
    display: none !important;
}
@import "@/styles/inventory_management.scss";
</style>